module.exports = __webpack_public_path__ + "img/serve.4df43272.png";